import { ScanBarcode, Settings2 } from 'lucide-react';
import FichaPrevia from '../alta-escaneo/FichaPrevia';
import AjustesAltaEscaneo from '../alta-escaneo/AjustesAltaEscaneo';
import { ID_AJUSTES, ID_FICHA } from '../alta-escaneo/ficha';

/* =====================================================================
   Las pantallas del carril `alta-escaneo` · DIRECTRIZ-ALTA-POR-ESCANEO
   =====================================================================
   «Dar de alta escaneando» (F5–F7) en Operación, con el permiso
   `catalogo` (el mismo de la ficha en el servidor) y desde ENCARGADO,
   que es quien da de alta productos. Se abre desde el menú; con
   `irA('alta-escaneo', { codigo, medio })` llega con el código puesto.

   «Catálogo que aprende» (R-AE1) en Administración, desde ADMIN: es quien
   puede cambiar el interruptor (`PUT /api/alta-escaneo/ajustes`).
   ===================================================================== */
export default {
  orden: 41,
  grupos: [
    {
      grupo: 'Operación',
      items: [
        { id: ID_FICHA, etiqueta: 'Dar de alta escaneando', icono: ScanBarcode, permiso: 'catalogo',
          min: 'ENCARGADO', Comp: FichaPrevia },
      ],
    },
    {
      grupo: 'Administración',
      items: [
        { id: ID_AJUSTES, etiqueta: 'Catálogo que aprende', icono: Settings2, min: 'ADMIN',
          Comp: AjustesAltaEscaneo },
      ],
    },
  ],
};
